import { useAccount, useNetwork, useSwitchNetwork } from 'wagmi'
import { useWeb3Modal } from '@web3modal/wagmi/react'

export default function ConnectWallet() {
  const { chain } = useNetwork()
  const { chains, switchNetwork } = useSwitchNetwork()
  const { address } = useAccount()
  const { open } = useWeb3Modal()

  return (
    <div className="d-flex justify-content-center mt-3">
      <button
        className="button-5 sus py-2 w-100"
        onClick={() =>
          address ? (chain?.id == chains[0]?.id ? open() : switchNetwork?.(chains[0]?.id)) : open()
        }
      >
        {address ? (
          chain?.id == chains[0]?.id || chain?.id == chains[1]?.id ? (
            address ? (
              <>{`${address?.substring(0, 6)}...${address?.substring(address.length - 4)}`}</>
            ) : (
              <>Connect Wallet</>
            )
          ) : (
            'Switch Network'
          )
        ) : (
          <>Connect Wallet</>
        )}
      </button>
    </div>
  )
}
